module.exports = __webpack_public_path__ + "img/sjzy.a036ba45.png";